import * as React from "react";
import { HouseHeart, HouseHeartFill } from "react-bootstrap-icons";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

import "../styles/save-the-date.css";

const SaveTheDate = () => (
  <>
    <Helmet>
      <title>Save the Date</title>
    </Helmet>
    <div className="save-the-date-container w-100 h-100 text-light">
      <div className="home-button-container d-inline-block text-center">
        <Link className="link-light" to="/">
          <HouseHeartFill className="d-md-none" />
          <HouseHeart className="d-none d-md-block" />
        </Link>
      </div>
      <div className="content-container text-container d-none d-md-flex align-items-center justify-content-between w-100">
        <div className="title">Save the Date</div>
        <div className="details-container d-flex flex-column align-items-center justify-content-between text-uppercase">
          <div className="date">05.15.23</div>
          <div className="secondary-details-container d-flex flex-column align-items-center">
            <div>{"Snigdha & Sushain · Houston, TX"}</div>
            <div>Formal invitation to follow</div>
          </div>
        </div>
      </div>
      <div className="d-md-none">
        <div className="title-container text-container d-flex flex-column align-items-center justify-content-between w-100">
          <div className="title">Save the Date</div>
          <div className="date m-0">05.15.23</div>
        </div>
        <div className="details-container text-container d-flex flex-column align-items-center justify-content-between text-uppercase w-100">
          <div>{"Snigdha & Sushain · Houston, TX"}</div>
          <div>Formal invitation to follow</div>
        </div>
      </div>
    </div>
  </>
);

export default SaveTheDate;
